import { $generateNodesFromDOM } from '@lexical/html'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot, $insertNodes } from 'lexical'
import { useEffect } from 'react'

type Props = {
  html: string
}

/** Plugin that imports HTML content into Lexical */
function HtmlImportPlugin({ html }: Props) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (!html) return

    editor.update(() => {
      const parser = new DOMParser()
      const dom = parser.parseFromString(html, 'text/html')
      const nodes = $generateNodesFromDOM(editor, dom)

      const root = $getRoot()

      root.clear()
      $insertNodes(nodes)
    })
  }, [editor, html])

  return null
}

export default HtmlImportPlugin
